<!--
 * @Author: 刘小博
 * @Date: 2022-10-28 14:44:25
 * @LastEditTime: 2022-11-09 15:02:45
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\App.vue
 * 文件备注
-->
<template>
  <a-config-provider :locale="local">
    <div id="app"><router-view :key="$store.state.pageRouterKey" /></div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  data: () => ({
    local: zhCN
  })
}
</script>

<style lang="less">
@import url('~@/assets/style/common.less');
#app {
  height: 100%;
}
</style>
